"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldDestinationBase = void 0;
var tslib_1 = require("tslib");
var import_field_info_1 = require("../../model/import-field-info");
var destination_1 = require("../destination");
var FieldDestinationBase = (function (_super) {
    tslib_1.__extends(FieldDestinationBase, _super);
    function FieldDestinationBase() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FieldDestinationBase.prototype.processFieldBegin = function (disableUpdate, locked, hideByParent) {
        var fieldInfo = new import_field_info_1.ImportFieldInfo();
        fieldInfo.disableUpdate = disableUpdate;
        fieldInfo.locked = locked;
        fieldInfo.hideByParent = hideByParent;
        fieldInfo.index = this.data.subDocumentInfo.fieldImporter.currIndex++;
        this.data.subDocumentInfo.fieldImporter.processFieldBegin(fieldInfo);
    };
    FieldDestinationBase.prototype.processFieldSeparator = function () {
        var _this = this;
        this.data.subDocumentInfo.fieldImporter.applyToLastField(function (fieldInfo) {
            if (fieldInfo.codeEndPos == -1)
                _this.data.subDocumentInfo.fieldImporter.processFieldSeparator(fieldInfo);
        });
    };
    FieldDestinationBase.prototype.processFieldEnd = function () {
        var _this = this;
        this.data.subDocumentInfo.fieldImporter.applyToLastField(function (fieldInfo) {
            var field = _this.data.subDocumentInfo.fieldImporter.processFieldEnd(fieldInfo);
            if (_this.data.subDocumentInfo.fieldImporter.fieldInfoStack.count > 0)
                _this.data.subDocumentInfo.fieldImporter.fieldInfoStack.last.nestedFields.push(field);
        });
    };
    return FieldDestinationBase;
}(destination_1.ElementDestination));
exports.FieldDestinationBase = FieldDestinationBase;
